import { FC } from 'react';
import Link from 'next/link';
import { RUSSIAN_ALPHABET, ENGLISH_ALPHABET } from '@/helpers/variables';
import styles from './AlphabetSearch.module.scss';

interface IAlphabetSearch {
  title: string;
  url: string;
  letterSign: string;
}

const AlphabetSearch: FC<IAlphabetSearch> = ({ url, letterSign, title }) => {
  const currentLetterPage = letterSign?.toUpperCase();

  return (
    <div className={styles.alphabetSearch}>
      <div className={styles.alphabetSearch__title}>{title}</div>
      <div className={styles.alphabetSearch__wrap}>
        <div className={styles.alphabetSearch__row}>
          {RUSSIAN_ALPHABET.map((word) => (
            <Link prefetch={false} key={word} className={currentLetterPage === word ? `${styles.alphabetSearch__link} ${styles.alphabetSearch__link_current}` : `${styles.alphabetSearch__link}`} href={`${url}${word.toLowerCase()}`}>
              {word}
            </Link>
          ))}
        </div>
        <div className={styles.alphabetSearch__row}>
          {ENGLISH_ALPHABET.map((word) => (
            <Link prefetch={false} key={word} className={currentLetterPage === word ? `${styles.alphabetSearch__link} ${styles.alphabetSearch__link_current}` : `${styles.alphabetSearch__link}`} href={`${url}${word.toLowerCase()}`}>
              {word}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AlphabetSearch;
